module.exports = __webpack_public_path__ + "img/dateEXP.8a0b77f3.png";